/*global jQuery */
(function($) {
  
  jQuery('li.nav-item').hover(function() {
      jQuery(this).find('.dropdown-menu').addClass('show');
    }, function() {
      jQuery(this).find('.dropdown-menu').removeClass('show');
  });

  $('.prodotto').hover( function(){
    $( this ).find( ".img1" ).addClass('d-none');
    $( this ).find( ".img2" ).removeClass('d-none');
  }, function() {
    $( this ).find( ".img1" ).removeClass('d-none');
    $( this ).find( ".img2" ).addClass('d-none');
  });


  var attivaModal = function(message, buttons, idButtons, callBack) {
    $('.modal-body p').hide();
    $('.modal-body p').html(message);
    $('.modal-body p').show();

    if (!$('.modal').hasClass('in')) {
      $('.modal').modal('show');
    }

    $('.modal-footer').html('');

    if (typeof buttons !== 'undefined' && buttons !== null) {
      if (buttons.length > 0) {
        $.each(buttons, function(index, value) {
          if (idButtons[index] === '') {
            $('.modal-footer').append('<button type="button" class="btn btn-default" data-dismiss="modal">' + value + '</button>');
          } else {
            $('.modal-footer').append('<button type="button" class="btn btn-default" id="modal-action-' + idButtons[index] + '">' + value + '</button>');
          }
        });
      }
    }
    if (typeof callBack === 'function') {
      callBack();
    }
  };

      $('body').on('click', '.invia-contatto', function() {
      var validator = $('#form-contatto').validate({
        focusInvalid: false,
        onkeyup: false,
        onfocusout: false,
        errorElement: 'p',
        errorPlacement: function(error) {
          var tmpl = '<span class="glyphicon glyphicon-remove-circle" style="font-size: 70px; color:orange;"></span><br><br>' +
          '<h4>' + $(error).html() + '</h4><br>';

          attivaModal(tmpl, ['Chiudi'], ['']);

          $('div#errors').show();
          if ($('div#errors').html() === '') {
            error.appendTo('div#errors');
          }
        },
        rules: {
          nominativo: {
            required: true
          },
          azienda: {
            required: true
          },
          email: {
            required: true,
            email: true
          },
          telefono: {
            required: true
          },
          localita: {
            required: false
          },
          check_privacy: {
            required: true
          },
        },
        messages: {
          nominativo: {
            required: setup.texts.testi['inserire-nominativo']
          },
          azienda: {
            required: setup.texts.testi['inserire-azienda']
          },
          email: {
            required: setup.texts.testi['inserire-mail'],
            email: setup.texts.testi['mail-corretta']
          },
          telefono: {
            required: setup.texts.testi['inserire-telefono']
          },
          localita: {
            required: setup.texts.testi['inserire-localita']
          },
          check_privacy: {
            required: setup.texts.testi['check-privacy']
          },
        },
        invalidHandler: function() {
          $('div#errors').html('');
        }
      });

      var arr = {};
      
      arr.nominativo = $('#nominativo').val();
      arr.azienda = $('#azienda').val();
      arr.email = $('#email').val();
      arr.telefono = $('#telefono').val();
      arr.messaggio = $('#messaggio').val();
      arr.localita = $('#localita').val();
      arr.id_interesse = $('#id_interesse').val();
      arr.captcha = $('#captcha').val();
      console.log(arr);

      arr.check_privacy = $('#check_privacy').is(':checked');
      arr.check_commercial = $('#check_commercial').is(':checked');

      arr.id_pagina = $('#id_pagina').val();
      arr.pagina = $('#pagina').val();
      var jsonString = JSON.stringify(arr);


      if (validator.form()) {
        var tmpl = '<span class="glyphicon glyphicon-time" style="font-size: 70px; color:orange;"></span><br><br>' +
        '<h4>' + window.attendere + '</h4><br><br>';
        attivaModal(tmpl, null, null);
        //console.log($('#allegato')[0].files[0]);
        //console.log($('#allegato'));
        var fd = new FormData();
        fd.append('action', 'invia-contatto');
        fd.append('obj', jsonString);
        fd.append('language', window.language);
        if($('#allegato').val()) fd.append('image', $('#allegato')[0].files[0]);

        $.ajax({
          url: '/ajax/function.php',
          method: 'POST',
          contentType: false,
          processData: false,
          data: fd,
          success: function(ret) {
            var arr = ret.split('|');
            var tmpl = '';

            if (arr[0] === '1') {
              tmpl = '<span class="glyphicon glyphicon-send" style="font-size: 70px; color:orange;"></span><br><br><h4>' + arr[1] + '</h4><br><br>';
              $('#email').val('');
              $('#nominativo').val('');
              $('#azienda').val('');
              $('#telefono').val('');
              $('#check_privacy').val('');
              $('#messaggio').val('');
              
              //gtag('event', 'click', {
              //  'event_category': 'Contact',
              //  'event_label': 'compilazione form'
              //});
              

            } else {
              tmpl = '<span class="glyphicon glyphicon-remove-sign" style="font-size: 70px; color:orange;"></span><br><br><h4>' + arr[1] + '</h4><br><br>';
            }
            attivaModal(tmpl, ['Chiudi'], [''], null);
          }
        });
        return false;
      }
      return false;
    });


}(jQuery));
